import { HTTPMETHOD } from '../../../../../enums/HTTPMETHOD.js';
import DIALOG from '../../../../DOM/dialog/DIALOG.js';
import CONFIRM, { confirmEl } from '../../../../COMPONENT/dialog/confirm/CONFIRM.js';
import { fieldset } from '../../../../DOM/form/fieldset/FIELDSET.js';
import { formInputPassword } from '../../../../DOM/form/fieldset/formfieldgroup/formfield/forminput/forminputs/FORMINPUTPASSWORD.js';
import { formInputText } from '../../../../DOM/form/fieldset/formfieldgroup/formfield/forminput/forminputs/FORMINPUTTEXT.js';
import { formFieldGroup } from '../../../../DOM/form/fieldset/formfieldgroup/FORMFIELDGROUP.js';
import { legend } from '../../../../DOM/form/fieldset/legend/LEGEND.js';
import FORM, { form } from '../../../../DOM/form/FORM.js';
import { text } from '../../../../DOM/text/TEXT.js';
import { makeAttrStruct } from '../../../../../enums/ModelAttr.js';
import { makeStruct } from '../../../../../enums/MODELS.js';
import { makeDataStruct } from '../../../../../enums/ModelData.js';
import { label } from '../../../../DOM/form/label/LABEL.js';
import { inputPassword } from '../../../../DOM/form/fieldset/field/input/inputs/INPUTPASSWORD.js';
import { inputText } from '../../../../DOM/form/fieldset/field/input/inputs/INPUTTEXT.js';
import { buttongroup } from '../../../../DOM/GROUP/buttongroup/BUTTONGROUP.js';
import { button } from '../../../../DOM/button/BUTTON.js';
import { span } from '../../../../DOM/span/SPAN.js';
import { SVGS } from '../../../../SVG/SVGS.js';
import { icon } from '../../../../SVG/icon/ICON.js';
import { navheader } from '../../../../DOM/nav/navbar/navheader/NAVHEADER.js';
import { navfooter } from '../../../../DOM/nav/navbar/navfooter/NAVFOOTER.js';
// Model Structure
export const loginDialogAttr = makeAttrStruct([
    ['open'],
    ['closeOnFocusOut', true]
]);
export const loginDialogData = makeDataStruct([
    ['loginUrl'],
    ['caller', null],
    ['loader'],
    ['header', navheader()],
    ['footer', navfooter()],
    ['text', text('Please log in to continue')],
    ['onConfirm', () => { }],
    ['onCancel', () => { }]
]);
export const loginDialogModel = makeStruct([
    ['attributes', loginDialogAttr],
    ['data', loginDialogData]
]);
// Simplified Model
export function loginDialog(loginUrl, caller, loader, text, header, footer) {
    return {
        attributes: loginDialogAttr(),
        data: loginDialogData(loginUrl, caller, loader, text, header, footer)
    };
}
/** A DIALOG with an embedded FORM that can be used to recieve input
    @description Creates a dialog and displays a text well and any included buttons
*/
export default class LOGIN extends DIALOG {
    form;
    constructor(node, model) {
        super(node, model);
        this.addClass('login');
        this.loginUrl = model.data.loginUrl;
        this.form = new FORM(this.flexvertical.middle, form('login', 'form-login', model.data.loginUrl, HTTPMETHOD.POST));
        let fs = this.form.addFieldset(fieldset('credentials', 'fieldset-credentials'));
        fs.addLegend(legend('Credentials'));
        let ffGroup = fs.addFormFieldGroup(formFieldGroup('credentials'));
        ffGroup.addFormInputText(formInputText(label('Username'), inputText('username', '', String(window.sessionStorage.getItem('username') || ''), '', true)));
        ffGroup.addFormInputPassword(formInputPassword(label('Password'), inputPassword('password')));
        let btnGroup = ffGroup.addButtonGroup(buttongroup('actions', 'vertical'));
        btnGroup.addButton(button(span('Sign In'), 'submit', icon(SVGS.CHECKMARK), '', 'confirm dialog-button')).on('click', () => {
            let formResults = this.form.getResults().credentials.credentials[0];
            if (formResults.username !== '' && formResults.password !== '') {
                this.getJson(this.loginUrl, (payload) => this.loginHandler(payload), HTTPMETHOD.POST, undefined, undefined, formResults);
            }
            else {
                let confirmDialog = new CONFIRM(this.caller.getMain().getBody(), confirmEl('login-failed', 'error no-cancel', this, navheader(), navfooter(), text('Username and Password are required to login')));
                confirmDialog.show();
            }
        });
        this.caller.on('deactivate', () => this.closeDialog());
    }
    checkEmpty(field) {
        if (String(field.getValue()).length) {
            field.removeClass('empty');
        }
        else {
            field.addClass('empty');
        }
    }
    /** Handles the Login Payload
        @param {{ [key: string]: any; }} payload Login Payload
    */
    loginHandler(payload) {
        console.log('loginHandler');
        try {
            if (payload.error === 'Invalid credentials') {
                console.log('Unable to Authenticate', payload);
                let confirmDialog = new CONFIRM(this.caller.getMain().getBody(), confirmEl('login-failed', 'error no-cancel', this, navheader(), navfooter(), text(payload.detail || 'Login failed due to invalid credentials. Please try again.')));
                confirmDialog.setAttribute('style', 'height:300px');
                confirmDialog.show();
                // Make some sort of visual cue to inform user to attempt again
            }
            else {
                console.log('LOGIN FORM', payload);
                // Save Session details in sessionStorage
                Object.keys(payload).forEach((key) => window.sessionStorage.setItem(key, payload[key]));
                // Close the loader, dialog etc and trigger page load
                this.data.loader.log(100, 'Login Successful').then(() => {
                    // Prompt for Browser Save Password
                    history.pushState({}, document.title);
                    // Initialize
                    this.closeDialog().then(() => {
                        console.log(window.sessionStorage);
                        console.log('Reloading page');
                        location.reload();
                    });
                });
            }
        }
        catch (e) {
            if (!(e instanceof TypeError)) {
                console.error('Unknown error occurred', e);
            }
        }
    }
}
